window.HS_SWATCH_DATA = window.HS_SWATCH_DATA || {};
window.HS_SWATCH_DATA["zebra-semi-blackout"] = {
  "product_key": "zebra-semi-blackout",
  "minimum_order_quantity": 5,
  "tier_guide": [
    {
      "tier": "Tier 1",
      "label": "Budget Friendly"
    },
    {
      "tier": "Tier 2",
      "label": "Residential Collection"
    },
    {
      "tier": "Tier 3",
      "label": "Premium Collection"
    },
    {
      "tier": "Tier 4",
      "label": "Luxury Collection"
    }
  ],
  "swatches": [
    {
      "id": "zebra-semi-blackout-DE6-001",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Semi-Blackout - Budget Friendly",
      "fabric_series": "DE6",
      "fabric_code": "DE6-001",
      "web_name": "Bright Ice White",
      "name_key": "bright-ice-white",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MDgxNTUyNDA1OS1ERTYtMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9180815524059-DE6-1.jpg",
      "search_text": "DE6-001 Bright Ice White Budget Friendly",
      "sort_order": 465,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE6-002",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Semi-Blackout - Budget Friendly",
      "fabric_series": "DE6",
      "fabric_code": "DE6-002",
      "web_name": "Cool Mist Silver",
      "name_key": "cool-mist-silver",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MDgxNTUyNDA1OS1ERTYtMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9180815524059-DE6-2.jpg",
      "search_text": "DE6-002 Cool Mist Silver Budget Friendly",
      "sort_order": 466,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE6-003",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Semi-Blackout - Budget Friendly",
      "fabric_series": "DE6",
      "fabric_code": "DE6-003",
      "web_name": "Deep Iron Grey",
      "name_key": "deep-iron-grey",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MDgxNTUyNDA1OS1ERTYtMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9180815524059-DE6-3.jpg",
      "search_text": "DE6-003 Deep Iron Grey Budget Friendly",
      "sort_order": 467,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE6-004",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Semi-Blackout - Budget Friendly",
      "fabric_series": "DE6",
      "fabric_code": "DE6-004",
      "web_name": "Warm Stone Beige",
      "name_key": "warm-stone-beige",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MDgxNTUyNDA1OS1ERTYtNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9180815524059-DE6-4.jpg",
      "search_text": "DE6-004 Warm Stone Beige Budget Friendly",
      "sort_order": 468,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE7-001",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Semi-Blackout - Budget Friendly",
      "fabric_series": "DE7",
      "fabric_code": "DE7-001",
      "web_name": "Pure Grid White",
      "name_key": "pure-grid-white",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MDgxNTUyNDA1OS1ERTctMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9180815524059-DE7-1.jpg",
      "search_text": "DE7-001 Pure Grid White Budget Friendly",
      "sort_order": 469,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE7-002",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Semi-Blackout - Budget Friendly",
      "fabric_series": "DE7",
      "fabric_code": "DE7-002",
      "web_name": "Golden Sand Mesh",
      "name_key": "golden-sand-mesh",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MDgxNTUyNDA1OS1ERTctMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9180815524059-DE7-2.jpg",
      "search_text": "DE7-002 Golden Sand Mesh Budget Friendly",
      "sort_order": 470,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE7-003",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Semi-Blackout - Budget Friendly",
      "fabric_series": "DE7",
      "fabric_code": "DE7-003",
      "web_name": "Silver Grid Mesh",
      "name_key": "silver-grid-mesh",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MDgxNTUyNDA1OS1ERTctMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9180815524059-DE7-3.jpg",
      "search_text": "DE7-003 Silver Grid Mesh Budget Friendly",
      "sort_order": 471,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE7-004",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Semi-Blackout - Budget Friendly",
      "fabric_series": "DE7",
      "fabric_code": "DE7-004",
      "web_name": "Natural Cane Mesh",
      "name_key": "natural-cane-mesh",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MDgxNTUyNDA1OS1ERTctNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9180815524059-DE7-4.jpg",
      "search_text": "DE7-004 Natural Cane Mesh Budget Friendly",
      "sort_order": 472,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE7-005",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Semi-Blackout - Budget Friendly",
      "fabric_series": "DE7",
      "fabric_code": "DE7-005",
      "web_name": "Dark Coal Mesh",
      "name_key": "dark-coal-mesh",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MDgxNTUyNDA1OS1ERTctNS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9180815524059-DE7-5.jpg",
      "search_text": "DE7-005 Dark Coal Mesh Budget Friendly",
      "sort_order": 473,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE8-001",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Semi-Blackout - Budget Friendly",
      "fabric_series": "DE8",
      "fabric_code": "DE8-001",
      "web_name": "Soft Birch White",
      "name_key": "soft-birch-white",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MDgxNTUyNDA1OS1ERTgtMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9180815524059-DE8-1.jpg",
      "search_text": "DE8-001 Soft Birch White Budget Friendly",
      "sort_order": 474,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE9-001",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Semi-Blackout - Budget Friendly",
      "fabric_series": "DE9",
      "fabric_code": "DE9-001",
      "web_name": "Pale Woven White",
      "name_key": "pale-woven-white",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MDgxNTUyNDA1OS1ERTktMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9180815524059-DE9-1.jpg",
      "search_text": "DE9-001 Pale Woven White Budget Friendly",
      "sort_order": 475,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE9-002",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Semi-Blackout - Budget Friendly",
      "fabric_series": "DE9",
      "fabric_code": "DE9-002",
      "web_name": "Cool Steel Grey",
      "name_key": "cool-steel-grey",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MDgxNTUyNDA1OS1ERTktMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9180815524059-DE9-2.jpg",
      "search_text": "DE9-002 Cool Steel Grey Budget Friendly",
      "sort_order": 476,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE9-003",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Semi-Blackout - Budget Friendly",
      "fabric_series": "DE9",
      "fabric_code": "DE9-003",
      "web_name": "Smoky Taupe Grey",
      "name_key": "smoky-taupe-grey",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MDgxNTUyNDA1OS1ERTktMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9180815524059-DE9-3.jpg",
      "search_text": "DE9-003 Smoky Taupe Grey Budget Friendly",
      "sort_order": 477,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE11-001",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Semi-Blackout - Budget Friendly",
      "fabric_series": "DE11",
      "fabric_code": "DE11-001",
      "web_name": "Frost Reed White",
      "name_key": "frost-reed-white",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MDgxNTUyNDA1OS1ERTExLTEuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9180815524059-DE11-1.jpg",
      "search_text": "DE11-001 Frost Reed White Budget Friendly",
      "sort_order": 478,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE11-002",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Semi-Blackout - Budget Friendly",
      "fabric_series": "DE11",
      "fabric_code": "DE11-002",
      "web_name": "Warm Straw Cream",
      "name_key": "warm-straw-cream",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MDgxNTUyNDA1OS1ERTExLTIuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9180815524059-DE11-2.jpg",
      "search_text": "DE11-002 Warm Straw Cream Budget Friendly",
      "sort_order": 479,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE11-003",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Semi-Blackout - Budget Friendly",
      "fabric_series": "DE11",
      "fabric_code": "DE11-003",
      "web_name": "Soft Pebble Taupe",
      "name_key": "soft-pebble-taupe",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MDgxNTUyNDA1OS1ERTExLTMuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9180815524059-DE11-3.jpg",
      "search_text": "DE11-003 Soft Pebble Taupe Budget Friendly",
      "sort_order": 480,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE14-001",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Semi-Blackout - Budget Friendly",
      "fabric_series": "DE14",
      "fabric_code": "DE14-001",
      "web_name": "Bright Snow White",
      "name_key": "bright-snow-white",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MDgxNTUyNDA1OS1ERTE0LTEuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9180815524059-DE14-1.jpg",
      "search_text": "DE14-001 Bright Snow White Budget Friendly",
      "sort_order": 481,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE14-002",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Semi-Blackout - Budget Friendly",
      "fabric_series": "DE14",
      "fabric_code": "DE14-002",
      "web_name": "Classic Pearl White",
      "name_key": "classic-pearl-white",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MDgxNTUyNDA1OS1ERTE0LTIuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9180815524059-DE14-2.jpg",
      "search_text": "DE14-002 Classic Pearl White Budget Friendly",
      "sort_order": 482,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE14-003",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Semi-Blackout - Budget Friendly",
      "fabric_series": "DE14",
      "fabric_code": "DE14-003",
      "web_name": "Warm Desert Sand",
      "name_key": "warm-desert-sand",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MDgxNTUyNDA1OS1ERTE0LTMuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9180815524059-DE14-3.jpg",
      "search_text": "DE14-003 Warm Desert Sand Budget Friendly",
      "sort_order": 483,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE14-004",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Semi-Blackout - Budget Friendly",
      "fabric_series": "DE14",
      "fabric_code": "DE14-004",
      "web_name": "Soft Silver Grey",
      "name_key": "soft-silver-grey",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MDgxNTUyNDA1OS1ERTE0LTQuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9180815524059-DE14-4.jpg",
      "search_text": "DE14-004 Soft Silver Grey Budget Friendly",
      "sort_order": 484,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE14-005",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Semi-Blackout - Budget Friendly",
      "fabric_series": "DE14",
      "fabric_code": "DE14-005",
      "web_name": "Natural Stone Grey",
      "name_key": "natural-stone-grey",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MDgxNTUyNDA1OS1ERTE0LTUuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9180815524059-DE14-5.jpg",
      "search_text": "DE14-005 Natural Stone Grey Budget Friendly",
      "sort_order": 485,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE20-001",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Semi-Blackout - Budget Friendly",
      "fabric_series": "DE20",
      "fabric_code": "DE20-001",
      "web_name": "Clean Arctic White",
      "name_key": "clean-arctic-white",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MDgxNTUyNDA1OS1ERTIwLTEuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9180815524059-DE20-1.jpg",
      "search_text": "DE20-001 Clean Arctic White Budget Friendly",
      "sort_order": 486,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE20-002",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Semi-Blackout - Budget Friendly",
      "fabric_series": "DE20",
      "fabric_code": "DE20-002",
      "web_name": "Light Linen Beige",
      "name_key": "light-linen-beige",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MDgxNTUyNDA1OS1ERTIwLTIuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9180815524059-DE20-2.jpg",
      "search_text": "DE20-002 Light Linen Beige Budget Friendly",
      "sort_order": 487,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE20-003",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Semi-Blackout - Budget Friendly",
      "fabric_series": "DE20",
      "fabric_code": "DE20-003",
      "web_name": "Cool Urban Grey",
      "name_key": "cool-urban-grey",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MDgxNTUyNDA1OS1ERTIwLTMuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9180815524059-DE20-3.jpg",
      "search_text": "DE20-003 Cool Urban Grey Budget Friendly",
      "sort_order": 488,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE20-004",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Semi-Blackout - Budget Friendly",
      "fabric_series": "DE20",
      "fabric_code": "DE20-004",
      "web_name": "Classic Warm Taupe",
      "name_key": "classic-warm-taupe",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MDgxNTUyNDA1OS1ERTIwLTQuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9180815524059-DE20-4.jpg",
      "search_text": "DE20-004 Classic Warm Taupe Budget Friendly",
      "sort_order": 489,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE22-001",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Semi-Blackout - Budget Friendly",
      "fabric_series": "DE22",
      "fabric_code": "DE22-001",
      "web_name": "Soft Polar White",
      "name_key": "soft-polar-white",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MDgxNTUyNDA1OS1ERTIyLTEuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9180815524059-DE22-1.jpg",
      "search_text": "DE22-001 Soft Polar White Budget Friendly",
      "sort_order": 490,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE22-002",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Semi-Blackout - Budget Friendly",
      "fabric_series": "DE22",
      "fabric_code": "DE22-002",
      "web_name": "Warm Ivory Beige",
      "name_key": "warm-ivory-beige",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MDgxNTUyNDA1OS1ERTIyLTIuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9180815524059-DE22-2.jpg",
      "search_text": "DE22-002 Warm Ivory Beige Budget Friendly",
      "sort_order": 491,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE22-003",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Semi-Blackout - Budget Friendly",
      "fabric_series": "DE22",
      "fabric_code": "DE22-003",
      "web_name": "Natural Sand Beige",
      "name_key": "natural-sand-beige",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MDgxNTUyNDA1OS1ERTIyLTMuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9180815524059-DE22-3.jpg",
      "search_text": "DE22-003 Natural Sand Beige Budget Friendly",
      "sort_order": 492,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE22-004",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Semi-Blackout - Budget Friendly",
      "fabric_series": "DE22",
      "fabric_code": "DE22-004",
      "web_name": "Light Desert Beige",
      "name_key": "light-desert-beige",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MDgxNTUyNDA1OS1ERTIyLTQuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9180815524059-DE22-4.jpg",
      "search_text": "DE22-004 Light Desert Beige Budget Friendly",
      "sort_order": 493,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE22-005",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Semi-Blackout - Budget Friendly",
      "fabric_series": "DE22",
      "fabric_code": "DE22-005",
      "web_name": "Natural Earth Taupe",
      "name_key": "natural-earth-taupe",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MDgxNTUyNDA1OS1ERTIyLTUuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9180815524059-DE22-5.jpg",
      "search_text": "DE22-005 Natural Earth Taupe Budget Friendly",
      "sort_order": 494,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE22-006",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Semi-Blackout - Budget Friendly",
      "fabric_series": "DE22",
      "fabric_code": "DE22-006",
      "web_name": "Modern Ash Grey",
      "name_key": "modern-ash-grey",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MDgxNTUyNDA1OS1ERTIyLTYuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9180815524059-DE22-6.jpg",
      "search_text": "DE22-006 Modern Ash Grey Budget Friendly",
      "sort_order": 495,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE22-007",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Semi-Blackout - Budget Friendly",
      "fabric_series": "DE22",
      "fabric_code": "DE22-007",
      "web_name": "Deep Graphite Grey",
      "name_key": "deep-graphite-grey",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MDgxNTUyNDA1OS1ERTIyLTcuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9180815524059-DE22-7.jpg",
      "search_text": "DE22-007 Deep Graphite Grey Budget Friendly",
      "sort_order": 496,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE12-001",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE12",
      "fabric_code": "DE12-001",
      "web_name": "Soft Weave White",
      "name_key": "soft-weave-white",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTEyLTEuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183223218395-DE12-1.jpg",
      "search_text": "DE12-001 Soft Weave White Residential Collection",
      "sort_order": 497,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE12-002",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE12",
      "fabric_code": "DE12-002",
      "web_name": "Warm Weave Sand",
      "name_key": "warm-weave-sand",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTEyLTIuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183223218395-DE12-2.jpg",
      "search_text": "DE12-002 Warm Weave Sand Residential Collection",
      "sort_order": 498,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE12-003",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE12",
      "fabric_code": "DE12-003",
      "web_name": "Cool Weave Grey",
      "name_key": "cool-weave-grey",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTEyLTMuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183223218395-DE12-3.jpg",
      "search_text": "DE12-003 Cool Weave Grey Residential Collection",
      "sort_order": 499,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE12-004",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE12",
      "fabric_code": "DE12-004",
      "web_name": "Deep Weave Graphite",
      "name_key": "deep-weave-graphite",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTEyLTQuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183223218395-DE12-4.jpg",
      "search_text": "DE12-004 Deep Weave Graphite Residential Collection",
      "sort_order": 500,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE12-005",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE12",
      "fabric_code": "DE12-005",
      "web_name": "Natural Weave Taupe",
      "name_key": "natural-weave-taupe",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTEyLTUuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183223218395-DE12-5.jpg",
      "search_text": "DE12-005 Natural Weave Taupe Residential Collection",
      "sort_order": 501,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE23-001",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE23",
      "fabric_code": "DE23-001",
      "web_name": "Frost Bark White",
      "name_key": "frost-bark-white",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTIzLTEuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183223218395-DE23-1.jpg",
      "search_text": "DE23-001 Frost Bark White Residential Collection",
      "sort_order": 502,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE23-002",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE23",
      "fabric_code": "DE23-002",
      "web_name": "Warm Bark Beige",
      "name_key": "warm-bark-beige",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTIzLTIuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183223218395-DE23-2.jpg",
      "search_text": "DE23-002 Warm Bark Beige Residential Collection",
      "sort_order": 503,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE23-003",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE23",
      "fabric_code": "DE23-003",
      "web_name": "Soft Bark Silver",
      "name_key": "soft-bark-silver",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTIzLTMuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183223218395-DE23-3.jpg",
      "search_text": "DE23-003 Soft Bark Silver Residential Collection",
      "sort_order": 504,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE23-004",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE23",
      "fabric_code": "DE23-004",
      "web_name": "Cool Bark Grey",
      "name_key": "cool-bark-grey",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTIzLTQuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183223218395-DE23-4.jpg",
      "search_text": "DE23-004 Cool Bark Grey Residential Collection",
      "sort_order": 505,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE23-005",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE23",
      "fabric_code": "DE23-005",
      "web_name": "Stone Bark Grey",
      "name_key": "stone-bark-grey",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTIzLTUuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183223218395-DE23-5.jpg",
      "search_text": "DE23-005 Stone Bark Grey Residential Collection",
      "sort_order": 506,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE23-006",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE23",
      "fabric_code": "DE23-006",
      "web_name": "Deep Bark Charcoal",
      "name_key": "deep-bark-charcoal",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTIzLTYuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183223218395-DE23-6.jpg",
      "search_text": "DE23-006 Deep Bark Charcoal Residential Collection",
      "sort_order": 507,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE1-001",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE1",
      "fabric_code": "DE1-001",
      "web_name": "Arctic White Linen",
      "name_key": "arctic-white-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTEtMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183223218395-DE1-1.jpg",
      "search_text": "DE1-001 Arctic White Linen Residential Collection",
      "sort_order": 508,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE1-002",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE1",
      "fabric_code": "DE1-002",
      "web_name": "Soft Grain Ivory",
      "name_key": "soft-grain-ivory",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTEtMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183223218395-DE1-2.jpg",
      "search_text": "DE1-002 Soft Grain Ivory Residential Collection",
      "sort_order": 509,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE1-003",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE1",
      "fabric_code": "DE1-003",
      "web_name": "Warm Grain Beige",
      "name_key": "warm-grain-beige",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTEtMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183223218395-DE1-3.jpg",
      "search_text": "DE1-003 Warm Grain Beige Residential Collection",
      "sort_order": 510,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE1-004",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE1",
      "fabric_code": "DE1-004",
      "web_name": "Cool Grain Grey",
      "name_key": "cool-grain-grey",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTEtNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183223218395-DE1-4.jpg",
      "search_text": "DE1-004 Cool Grain Grey Residential Collection",
      "sort_order": 511,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE1-005",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE1",
      "fabric_code": "DE1-005",
      "web_name": "Earth Grain Taupe",
      "name_key": "earth-grain-taupe",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTEtNS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183223218395-DE1-5.jpg",
      "search_text": "DE1-005 Earth Grain Taupe Residential Collection",
      "sort_order": 512,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE1-006",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE1",
      "fabric_code": "DE1-006",
      "web_name": "Rich Grain Black",
      "name_key": "rich-grain-black",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTEtNi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183223218395-DE1-6.jpg",
      "search_text": "DE1-006 Rich Grain Black Residential Collection",
      "sort_order": 513,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE1-007",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE1",
      "fabric_code": "DE1-007",
      "web_name": "Deep Grain Blue",
      "name_key": "deep-grain-blue",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTEtNy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183223218395-DE1-7.jpg",
      "search_text": "DE1-007 Deep Grain Blue Residential Collection",
      "sort_order": 514,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE13-001",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE13",
      "fabric_code": "DE13-001",
      "web_name": "Pearl Texture White",
      "name_key": "pearl-texture-white",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTEzLTEuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183223218395-DE13-1.jpg",
      "search_text": "DE13-001 Pearl Texture White Residential Collection",
      "sort_order": 515,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE13-002",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE13",
      "fabric_code": "DE13-002",
      "web_name": "Cream Texture Ivory",
      "name_key": "cream-texture-ivory",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTEzLTIuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183223218395-DE13-2.jpg",
      "search_text": "DE13-002 Cream Texture Ivory Residential Collection",
      "sort_order": 516,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE13-003",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE13",
      "fabric_code": "DE13-003",
      "web_name": "Silver Texture Grey",
      "name_key": "silver-texture-grey",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTEzLTMuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183223218395-DE13-3.jpg",
      "search_text": "DE13-003 Silver Texture Grey Residential Collection",
      "sort_order": 517,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE13-004",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE13",
      "fabric_code": "DE13-004",
      "web_name": "Graphite Texture Grey",
      "name_key": "graphite-texture-grey",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTEzLTQuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183223218395-DE13-4.jpg",
      "search_text": "DE13-004 Graphite Texture Grey Residential Collection",
      "sort_order": 518,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE17-001",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE17",
      "fabric_code": "DE17-001",
      "web_name": "Snow Line White",
      "name_key": "snow-line-white",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTE3LTEuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183223218395-DE17-1.jpg",
      "search_text": "DE17-001 Snow Line White Residential Collection",
      "sort_order": 519,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE17-002",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE17",
      "fabric_code": "DE17-002",
      "web_name": "Warm Line Sand",
      "name_key": "warm-line-sand",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTE3LTIuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183223218395-DE17-2.jpg",
      "search_text": "DE17-002 Warm Line Sand Residential Collection",
      "sort_order": 520,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE17-003",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE17",
      "fabric_code": "DE17-003",
      "web_name": "Natural Line Beige",
      "name_key": "natural-line-beige",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTE3LTMuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183223218395-DE17-3.jpg",
      "search_text": "DE17-003 Natural Line Beige Residential Collection",
      "sort_order": 521,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE17-004",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE17",
      "fabric_code": "DE17-004",
      "web_name": "Cool Line Grey",
      "name_key": "cool-line-grey",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTE3LTQuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183223218395-DE17-4.jpg",
      "search_text": "DE17-004 Cool Line Grey Residential Collection",
      "sort_order": 522,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE17-005",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE17",
      "fabric_code": "DE17-005",
      "web_name": "Stone Line Taupe",
      "name_key": "stone-line-taupe",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTE3LTUuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183223218395-DE17-5.jpg",
      "search_text": "DE17-005 Stone Line Taupe Residential Collection",
      "sort_order": 523,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE17-006",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE17",
      "fabric_code": "DE17-006",
      "web_name": "Dark Line Brown",
      "name_key": "dark-line-brown",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTE3LTYuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183223218395-DE17-6.jpg",
      "search_text": "DE17-006 Dark Line Brown Residential Collection",
      "sort_order": 524,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE21-001",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE21",
      "fabric_code": "DE21-001",
      "web_name": "Pure Matte White",
      "name_key": "pure-matte-white",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTIxLTEuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183223218395-DE21-1.jpg",
      "search_text": "DE21-001 Pure Matte White Residential Collection",
      "sort_order": 525,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE21-002",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE21",
      "fabric_code": "DE21-002",
      "web_name": "Soft Matte Pearl",
      "name_key": "soft-matte-pearl",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTIxLTIuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183223218395-DE21-2.jpg",
      "search_text": "DE21-002 Soft Matte Pearl Residential Collection",
      "sort_order": 526,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE21-003",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE21",
      "fabric_code": "DE21-003",
      "web_name": "Warm Matte Taupe",
      "name_key": "warm-matte-taupe",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTIxLTMuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183223218395-DE21-3.jpg",
      "search_text": "DE21-003 Warm Matte Taupe Residential Collection",
      "sort_order": 527,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE21-004",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE21",
      "fabric_code": "DE21-004",
      "web_name": "Cool Matte Silver",
      "name_key": "cool-matte-silver",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTIxLTQuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183223218395-DE21-4.jpg",
      "search_text": "DE21-004 Cool Matte Silver Residential Collection",
      "sort_order": 528,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE2-001",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE2",
      "fabric_code": "DE2-001",
      "web_name": "Bright Stripe White",
      "name_key": "bright-stripe-white",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTItMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183223218395-DE2-1.jpg",
      "search_text": "DE2-001 Bright Stripe White Residential Collection",
      "sort_order": 529,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE2-002",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE2",
      "fabric_code": "DE2-002",
      "web_name": "Warm Stripe Ivory",
      "name_key": "warm-stripe-ivory",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTItMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183223218395-DE2-2.jpg",
      "search_text": "DE2-002 Warm Stripe Ivory Residential Collection",
      "sort_order": 530,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE2-003",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE2",
      "fabric_code": "DE2-003",
      "web_name": "Cool Stripe Grey",
      "name_key": "cool-stripe-grey",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTItMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183223218395-DE2-3.jpg",
      "search_text": "DE2-003 Cool Stripe Grey Residential Collection",
      "sort_order": 531,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE2-004",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE2",
      "fabric_code": "DE2-004",
      "web_name": "Deep Stripe Black",
      "name_key": "deep-stripe-black",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTItNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183223218395-DE2-4.jpg",
      "search_text": "DE2-004 Deep Stripe Black Residential Collection",
      "sort_order": 532,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE18-001",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE18",
      "fabric_code": "DE18-001",
      "web_name": "Silver Chevron Pearl",
      "name_key": "silver-chevron-pearl",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTE4LTEuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183223218395-DE18-1.jpg",
      "search_text": "DE18-001 Silver Chevron Pearl Residential Collection",
      "sort_order": 533,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE18-002",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE18",
      "fabric_code": "DE18-002",
      "web_name": "Steel Chevron Silver",
      "name_key": "steel-chevron-silver",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTE4LTIuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183223218395-DE18-2.jpg",
      "search_text": "DE18-002 Steel Chevron Silver Residential Collection",
      "sort_order": 534,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE18-003",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE18",
      "fabric_code": "DE18-003",
      "web_name": "Stone Chevron Ash",
      "name_key": "stone-chevron-ash",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTE4LTMuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183223218395-DE18-3.jpg",
      "search_text": "DE18-003 Stone Chevron Ash Residential Collection",
      "sort_order": 535,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE18-004",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Residential Collection",
      "fabric_series": "DE18",
      "fabric_code": "DE18-004",
      "web_name": "Deep Chevron Onyx",
      "name_key": "deep-chevron-onyx",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzIyMzIxODM5NS1ERTE4LTQuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183223218395-DE18-4.jpg",
      "search_text": "DE18-004 Deep Chevron Onyx Residential Collection",
      "sort_order": 536,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE15-001",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Premium Collection",
      "fabric_series": "DE15",
      "fabric_code": "DE15-001",
      "web_name": "Soft Pearl Weave",
      "name_key": "soft-pearl-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI2NTc1MTI1OS1ERTE1LTEuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183265751259-DE15-1.jpg",
      "search_text": "DE15-001 Soft Pearl Weave Premium Collection",
      "sort_order": 537,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE15-002",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Premium Collection",
      "fabric_series": "DE15",
      "fabric_code": "DE15-002",
      "web_name": "Warm Sand Weave",
      "name_key": "warm-sand-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI2NTc1MTI1OS1ERTE1LTIuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183265751259-DE15-2.jpg",
      "search_text": "DE15-002 Warm Sand Weave Premium Collection",
      "sort_order": 538,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE15-003",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Premium Collection",
      "fabric_series": "DE15",
      "fabric_code": "DE15-003",
      "web_name": "Silver Pearl Weave",
      "name_key": "silver-pearl-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI2NTc1MTI1OS1ERTE1LTMuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183265751259-DE15-3.jpg",
      "search_text": "DE15-003 Silver Pearl Weave Premium Collection",
      "sort_order": 539,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE15-004",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Premium Collection",
      "fabric_series": "DE15",
      "fabric_code": "DE15-004",
      "web_name": "Mocha Pearl Weave",
      "name_key": "mocha-pearl-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI2NTc1MTI1OS1ERTE1LTQuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183265751259-DE15-4.jpg",
      "search_text": "DE15-004 Mocha Pearl Weave Premium Collection",
      "sort_order": 540,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE15-005",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Premium Collection",
      "fabric_series": "DE15",
      "fabric_code": "DE15-005",
      "web_name": "Cool Grey Weave",
      "name_key": "cool-grey-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI2NTc1MTI1OS1ERTE1LTUuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183265751259-DE15-5.jpg",
      "search_text": "DE15-005 Cool Grey Weave Premium Collection",
      "sort_order": 541,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE15-006",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Premium Collection",
      "fabric_series": "DE15",
      "fabric_code": "DE15-006",
      "web_name": "Graphite Pearl Weave",
      "name_key": "graphite-pearl-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI2NTc1MTI1OS1ERTE1LTYuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183265751259-DE15-6.jpg",
      "search_text": "DE15-006 Graphite Pearl Weave Premium Collection",
      "sort_order": 542,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE16-001",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Premium Collection",
      "fabric_series": "DE16",
      "fabric_code": "DE16-001",
      "web_name": "Snow Mesh White",
      "name_key": "snow-mesh-white",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI2NTc1MTI1OS1ERTE2LTEuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183265751259-DE16-1.jpg",
      "search_text": "DE16-001 Snow Mesh White Premium Collection",
      "sort_order": 543,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE16-002",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Premium Collection",
      "fabric_series": "DE16",
      "fabric_code": "DE16-002",
      "web_name": "Silver Mesh Fold",
      "name_key": "silver-mesh-fold",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI2NTc1MTI1OS1ERTE2LTIuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183265751259-DE16-2.jpg",
      "search_text": "DE16-002 Silver Mesh Fold Premium Collection",
      "sort_order": 544,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE16-003",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Premium Collection",
      "fabric_series": "DE16",
      "fabric_code": "DE16-003",
      "web_name": "Charcoal Mesh Fold",
      "name_key": "charcoal-mesh-fold",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI2NTc1MTI1OS1ERTE2LTMuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183265751259-DE16-3.jpg",
      "search_text": "DE16-003 Charcoal Mesh Fold Premium Collection",
      "sort_order": 545,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE3-001",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Premium Collection",
      "fabric_series": "DE3",
      "fabric_code": "DE3-001",
      "web_name": "White Open Mesh",
      "name_key": "white-open-mesh",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI2NTc1MTI1OS1ERTMtMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183265751259-DE3-1.jpg",
      "search_text": "DE3-001 White Open Mesh Premium Collection",
      "sort_order": 546,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE3-002",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Premium Collection",
      "fabric_series": "DE3",
      "fabric_code": "DE3-002",
      "web_name": "Cream Open Mesh",
      "name_key": "cream-open-mesh",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI2NTc1MTI1OS1ERTMtMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183265751259-DE3-2.jpg",
      "search_text": "DE3-002 Cream Open Mesh Premium Collection",
      "sort_order": 547,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE3-003",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Premium Collection",
      "fabric_series": "DE3",
      "fabric_code": "DE3-003",
      "web_name": "Sand Open Mesh",
      "name_key": "sand-open-mesh",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI2NTc1MTI1OS1ERTMtMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183265751259-DE3-3.jpg",
      "search_text": "DE3-003 Sand Open Mesh Premium Collection",
      "sort_order": 548,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE3-004",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Premium Collection",
      "fabric_series": "DE3",
      "fabric_code": "DE3-004",
      "web_name": "Silver Open Mesh",
      "name_key": "silver-open-mesh",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI2NTc1MTI1OS1ERTMtNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183265751259-DE3-4.jpg",
      "search_text": "DE3-004 Silver Open Mesh Premium Collection",
      "sort_order": 549,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE3-005",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Premium Collection",
      "fabric_series": "DE3",
      "fabric_code": "DE3-005",
      "web_name": "Slate Open Mesh",
      "name_key": "slate-open-mesh",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI2NTc1MTI1OS1ERTMtNS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183265751259-DE3-5.jpg",
      "search_text": "DE3-005 Slate Open Mesh Premium Collection",
      "sort_order": 550,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE3-006",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Premium Collection",
      "fabric_series": "DE3",
      "fabric_code": "DE3-006",
      "web_name": "Brown Open Mesh",
      "name_key": "brown-open-mesh",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI2NTc1MTI1OS1ERTMtNi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183265751259-DE3-6.jpg",
      "search_text": "DE3-006 Brown Open Mesh Premium Collection",
      "sort_order": 551,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE3-007",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Premium Collection",
      "fabric_series": "DE3",
      "fabric_code": "DE3-007",
      "web_name": "Black Open Mesh",
      "name_key": "black-open-mesh",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI2NTc1MTI1OS1ERTMtNy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183265751259-DE3-7.jpg",
      "search_text": "DE3-007 Black Open Mesh Premium Collection",
      "sort_order": 552,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE4-001",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Premium Collection",
      "fabric_series": "DE4",
      "fabric_code": "DE4-001",
      "web_name": "White Honeycomb Weave",
      "name_key": "white-honeycomb-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI2NTc1MTI1OS1ERTQtMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183265751259-DE4-1.jpg",
      "search_text": "DE4-001 White Honeycomb Weave Premium Collection",
      "sort_order": 553,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE4-002",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Premium Collection",
      "fabric_series": "DE4",
      "fabric_code": "DE4-002",
      "web_name": "Silver Honeycomb Weave",
      "name_key": "silver-honeycomb-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI2NTc1MTI1OS1ERTQtMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183265751259-DE4-2.jpg",
      "search_text": "DE4-002 Silver Honeycomb Weave Premium Collection",
      "sort_order": 554,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE4-003",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Premium Collection",
      "fabric_series": "DE4",
      "fabric_code": "DE4-003",
      "web_name": "Black Honeycomb Weave",
      "name_key": "black-honeycomb-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI2NTc1MTI1OS1ERTQtMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183265751259-DE4-3.jpg",
      "search_text": "DE4-003 Black Honeycomb Weave Premium Collection",
      "sort_order": 555,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DF1-001",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Premium Collection",
      "fabric_series": "DF1",
      "fabric_code": "DF1-001",
      "web_name": "Ivory Lattice Weave",
      "name_key": "ivory-lattice-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI2NTc1MTI1OS1ERjEtMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183265751259-DF1-1.jpg",
      "search_text": "DF1-001 Ivory Lattice Weave Premium Collection",
      "sort_order": 556,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DF1-002",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Premium Collection",
      "fabric_series": "DF1",
      "fabric_code": "DF1-002",
      "web_name": "Grey Lattice Weave",
      "name_key": "grey-lattice-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI2NTc1MTI1OS1ERjEtMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183265751259-DF1-2.jpg",
      "search_text": "DF1-002 Grey Lattice Weave Premium Collection",
      "sort_order": 557,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DF1-003",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Premium Collection",
      "fabric_series": "DF1",
      "fabric_code": "DF1-003",
      "web_name": "Black Lattice Weave",
      "name_key": "black-lattice-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI2NTc1MTI1OS1ERjEtMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183265751259-DF1-3.jpg",
      "search_text": "DF1-003 Black Lattice Weave Premium Collection",
      "sort_order": 558,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE5-001",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 4",
      "collection_label": "Luxury Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Luxury Collection",
      "fabric_series": "DE5",
      "fabric_code": "DE5-001",
      "web_name": "Pure Snow Weave",
      "name_key": "pure-snow-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI3Mjc5NjM3OS1ERTUtMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183272796379-DE5-1.jpg",
      "search_text": "DE5-001 Pure Snow Weave Luxury Collection",
      "sort_order": 559,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE19-001",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 4",
      "collection_label": "Luxury Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Luxury Collection",
      "fabric_series": "DE19",
      "fabric_code": "DE19-001",
      "web_name": "Soft Pearl White",
      "name_key": "soft-pearl-white",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI3Mjc5NjM3OS1ERTE5LTEuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183272796379-DE19-1.jpg",
      "search_text": "DE19-001 Soft Pearl White Luxury Collection",
      "sort_order": 560,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE19-002",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 4",
      "collection_label": "Luxury Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Luxury Collection",
      "fabric_series": "DE19",
      "fabric_code": "DE19-002",
      "web_name": "Warm Pearl Linen",
      "name_key": "warm-pearl-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI3Mjc5NjM3OS1ERTE5LTIuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183272796379-DE19-2.jpg",
      "search_text": "DE19-002 Warm Pearl Linen Luxury Collection",
      "sort_order": 561,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE19-003",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 4",
      "collection_label": "Luxury Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Luxury Collection",
      "fabric_series": "DE19",
      "fabric_code": "DE19-003",
      "web_name": "Cool Mist Linen",
      "name_key": "cool-mist-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI3Mjc5NjM3OS1ERTE5LTMuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183272796379-DE19-3.jpg",
      "search_text": "DE19-003 Cool Mist Linen Luxury Collection",
      "sort_order": 562,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE19-004",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 4",
      "collection_label": "Luxury Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Luxury Collection",
      "fabric_series": "DE19",
      "fabric_code": "DE19-004",
      "web_name": "Soft Ash Linen",
      "name_key": "soft-ash-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI3Mjc5NjM3OS1ERTE5LTQuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183272796379-DE19-4.jpg",
      "search_text": "DE19-004 Soft Ash Linen Luxury Collection",
      "sort_order": 563,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DE19-005",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 4",
      "collection_label": "Luxury Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Luxury Collection",
      "fabric_series": "DE19",
      "fabric_code": "DE19-005",
      "web_name": "Graphite Ash Linen",
      "name_key": "graphite-ash-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI3Mjc5NjM3OS1ERTE5LTUuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9183272796379-DE19-5.jpg",
      "search_text": "DE19-005 Graphite Ash Linen Luxury Collection",
      "sort_order": 564,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DF2-001",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 4",
      "collection_label": "Luxury Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Luxury Collection",
      "fabric_series": "DF2",
      "fabric_code": "DF2-001",
      "web_name": "Ivory Diamond Weave",
      "name_key": "ivory-diamond-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI3Mjc5NjM3OS1ERjItMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183272796379-DF2-1.jpg",
      "search_text": "DF2-001 Ivory Diamond Weave Luxury Collection",
      "sort_order": 565,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DF2-002",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 4",
      "collection_label": "Luxury Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Luxury Collection",
      "fabric_series": "DF2",
      "fabric_code": "DF2-002",
      "web_name": "Silver Diamond Weave",
      "name_key": "silver-diamond-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI3Mjc5NjM3OS1ERjItMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183272796379-DF2-2.jpg",
      "search_text": "DF2-002 Silver Diamond Weave Luxury Collection",
      "sort_order": 566,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DF3-001",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 4",
      "collection_label": "Luxury Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Luxury Collection",
      "fabric_series": "DF3",
      "fabric_code": "DF3-001",
      "web_name": "Gold Floral Weave",
      "name_key": "gold-floral-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI3Mjc5NjM3OS1ERjMtMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183272796379-DF3-1.jpg",
      "search_text": "DF3-001 Gold Floral Weave Luxury Collection",
      "sort_order": 567,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DF3-002",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 4",
      "collection_label": "Luxury Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Luxury Collection",
      "fabric_series": "DF3",
      "fabric_code": "DF3-002",
      "web_name": "Silver Floral Weave",
      "name_key": "silver-floral-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI3Mjc5NjM3OS1ERjMtMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183272796379-DF3-2.jpg",
      "search_text": "DF3-002 Silver Floral Weave Luxury Collection",
      "sort_order": 568,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DF4-001",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 4",
      "collection_label": "Luxury Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Luxury Collection",
      "fabric_series": "DF4",
      "fabric_code": "DF4-001",
      "web_name": "Gold Blossom Linen",
      "name_key": "gold-blossom-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI3Mjc5NjM3OS1ERjQtMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183272796379-DF4-1.jpg",
      "search_text": "DF4-001 Gold Blossom Linen Luxury Collection",
      "sort_order": 569,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DF4-002",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 4",
      "collection_label": "Luxury Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Luxury Collection",
      "fabric_series": "DF4",
      "fabric_code": "DF4-002",
      "web_name": "Silver Blossom Linen",
      "name_key": "silver-blossom-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI3Mjc5NjM3OS1ERjQtMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183272796379-DF4-2.jpg",
      "search_text": "DF4-002 Silver Blossom Linen Luxury Collection",
      "sort_order": 570,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DF5-001",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 4",
      "collection_label": "Luxury Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Luxury Collection",
      "fabric_series": "DF5",
      "fabric_code": "DF5-001",
      "web_name": "Soft Fern Linen",
      "name_key": "soft-fern-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI3Mjc5NjM3OS1ERjUtMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183272796379-DF5-1.jpg",
      "search_text": "DF5-001 Soft Fern Linen Luxury Collection",
      "sort_order": 571,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DF5-002",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 4",
      "collection_label": "Luxury Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Luxury Collection",
      "fabric_series": "DF5",
      "fabric_code": "DF5-002",
      "web_name": "Silver Fern Linen",
      "name_key": "silver-fern-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI3Mjc5NjM3OS1ERjUtMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183272796379-DF5-2.jpg",
      "search_text": "DF5-002 Silver Fern Linen Luxury Collection",
      "sort_order": 572,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DF6-001",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 4",
      "collection_label": "Luxury Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Luxury Collection",
      "fabric_series": "DF6",
      "fabric_code": "DF6-001",
      "web_name": "Warm Leaf Linen",
      "name_key": "warm-leaf-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI3Mjc5NjM3OS1ERjYtMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183272796379-DF6-1.jpg",
      "search_text": "DF6-001 Warm Leaf Linen Luxury Collection",
      "sort_order": 573,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DF6-002",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 4",
      "collection_label": "Luxury Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Luxury Collection",
      "fabric_series": "DF6",
      "fabric_code": "DF6-002",
      "web_name": "Soft Leaf Linen",
      "name_key": "soft-leaf-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI3Mjc5NjM3OS1ERjYtMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183272796379-DF6-2.jpg",
      "search_text": "DF6-002 Soft Leaf Linen Luxury Collection",
      "sort_order": 574,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DF6-003",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 4",
      "collection_label": "Luxury Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Luxury Collection",
      "fabric_series": "DF6",
      "fabric_code": "DF6-003",
      "web_name": "Graphite Leaf Linen",
      "name_key": "graphite-leaf-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI3Mjc5NjM3OS1ERjYtMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183272796379-DF6-3.jpg",
      "search_text": "DF6-003 Graphite Leaf Linen Luxury Collection",
      "sort_order": 575,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DF7-001",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 4",
      "collection_label": "Luxury Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Luxury Collection",
      "fabric_series": "DF7",
      "fabric_code": "DF7-001",
      "web_name": "Warm Abstract Linen",
      "name_key": "warm-abstract-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI3Mjc5NjM3OS1ERjctMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183272796379-DF7-1.jpg",
      "search_text": "DF7-001 Warm Abstract Linen Luxury Collection",
      "sort_order": 576,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DF7-002",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 4",
      "collection_label": "Luxury Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Luxury Collection",
      "fabric_series": "DF7",
      "fabric_code": "DF7-002",
      "web_name": "Soft Abstract Linen",
      "name_key": "soft-abstract-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI3Mjc5NjM3OS1ERjctMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183272796379-DF7-2.jpg",
      "search_text": "DF7-002 Soft Abstract Linen Luxury Collection",
      "sort_order": 577,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-semi-blackout-DF7-003",
      "roller_type": "zebra",
      "shade_type": "semi-blackout",
      "swatch_product_key": "zebra-semi-blackout",
      "tier": "Tier 4",
      "collection_label": "Luxury Collection",
      "source_product_label": "Zebra Shades Semi-Blackout - Luxury Collection",
      "fabric_series": "DF7",
      "fabric_code": "DF7-003",
      "web_name": "Graphite Abstract Linen",
      "name_key": "graphite-abstract-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MzI3Mjc5NjM3OS1ERjctMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9183272796379-DF7-3.jpg",
      "search_text": "DF7-003 Graphite Abstract Linen Luxury Collection",
      "sort_order": 578,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    }
  ]
};
